import { Modal, ModalContent } from '@chakra-ui/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useState } from 'react';
import xw from 'twin.macro';

const style: React.CSSProperties = {
  backgroundColor: '#fff',
  border: '0 none',
  boxSizing: 'border-box',
  display: 'inline-block',
  maxHeight: 'calc(100vh - 100px)',
  maxWidth: '100%',
  minWidth: 'initial',
  verticalAlign: 'middle',
};

const styles = {
  container: xw`box-border fixed inset-0 overflow-auto z-15001 flex dark:bg-gray-900 bg-gray-700`,
  content: xw`box-border max-w-full mx-auto my-0 dark:bg-black bg-white lg:table-row`,
  imageContainer: xw`box-border text-center relative inline-block`,
  imageContent: xw`box-border relative align-top text-center lg:table-cell`,
  innerLayout: xw`box-border max-h-full relative dark:bg-gray-700 bg-white lg:table`,
  metaContent: xw`w-full align-top relative box-border lg:table-cell lg:px-4 lg:w-72 dark:text-white text-black pb-6`,
  metaContentBody: xw`text-base dark:text-white text-black pt-8`,
  metaContentFooter: xw`lg:absolute bottom-0 border-2 border-green-200`,
  metaContentHeader: xw`flex justify-end`,
  outerLayout: xw`box-border m-auto`,
};

interface Props {
  body?: string;
  imageData: any;
  title?: string;
}

export const Lightbox = (props: Props) => {
  const { body, imageData, title } = props;

  const isCaptioned = Boolean(title);

  const [isOpen, setIsOpen] = useState(false);

  const handleCloseLightbox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      aria-label="open lightbox"
      className="relative h-full"
      role="button"
      tabIndex={0}
      onClick={handleCloseLightbox}
      onKeyDown={handleCloseLightbox}
    >
      <div className="relative block w-full h-full max-h-full overflow-hidden">
        <GatsbyImage
          alt=""
          className="w-full h-full aspect-w-16 aspect-h-9"
          image={imageData.childImageSharp.gatsbyImageData}
        />
      </div>
      <Modal
        isCentered
        isOpen={isOpen}
        size="full"
        onClose={handleCloseLightbox}
      >
        <ModalContent onClick={handleCloseLightbox}>
          <div css={[styles.container]}>
            <div css={[styles.outerLayout]}>
              <div css={[styles.innerLayout]}>
                <div css={[styles.content]}>
                  <div css={[styles.imageContent]}>
                    <div css={[styles.imageContainer]}>
                      <GatsbyImage
                        alt=""
                        className="w-full h-full drop-shadow-lg"
                        image={imageData.childImageSharp.gatsbyImageData}
                        style={style}
                      />
                    </div>
                  </div>
                  {isCaptioned && (
                    <div css={[styles.metaContent]}>
                      {/* <div css={[styles.metaContentHeader]}>
                          <button>Close</button>
                        </div> */}
                      <div css={[styles.metaContentBody]}>
                        <h3 className="mx-2 mb-4 text-lg text-black sm:mx-6 md:mx-8 dark:text-white">
                          {title}
                        </h3>
                        <p className="mx-2 text-base text-gray-800 sm:mx-6 md:mx-8 dark:text-gray-200">
                          {body}
                        </p>
                      </div>
                      {/* <div css={[styles.metaContentFooter]}>Footer</div> */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};
